var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('a-table',{ref:"tableRef",attrs:{"columns":_vm.columns,"dataSource":_vm.filteredTableData ?? _vm.tableData,"bordered":"","pagination":{ pageSize: 10 },"rowKey":(record) => record.key,"customRow":_vm.customRow}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }